import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '@/App';

const useSEO = (pageKey, defaultTitle = 'We Have Your Car') => {
  const [seoData, setSeoData] = useState(null);

  useEffect(() => {
    const fetchSEO = async () => {
      try {
        const response = await axios.get(`${API}/seo/${pageKey}`);
        setSeoData(response.data);
        
        // Update document title
        if (response.data?.title) {
          document.title = response.data.title;
        } else {
          document.title = defaultTitle;
        }
        
        // Update meta description
        if (response.data?.meta_description) {
          let metaDesc = document.querySelector('meta[name="description"]');
          if (metaDesc) {
            metaDesc.setAttribute('content', response.data.meta_description);
          }
        }
      } catch (error) {
        // Use default title if SEO data not found
        document.title = defaultTitle;
      }
    };

    fetchSEO();
  }, [pageKey, defaultTitle]);

  // Return seoData with h1, h2, title, meta_description
  return seoData || {};
};

export default useSEO;
